//@ts-check
import React from 'react';

import { getVariantsBySelections } from './product-utils';
import { IPdpData, TUserSelection } from '../types/PDP';

type Props = { pdpData: IPdpData; userSelections: Partial<TUserSelection>[] };
export const AlmostGoneCopyMessage = ({ pdpData, userSelections }: Props) => {
  const shouldShow = computeAlmostGoneBadging(pdpData, userSelections);
  return shouldShow ? <div className="almostGoneCopyMessage">Only a few left! Order Soon.</div> : null;
};

export const AlmostGoneImageMessage = ({ pdpData, userSelections }: Props) => {
  const shouldShow = computeAlmostGoneBadging(pdpData, userSelections);
  return shouldShow ? (
    <div className="almostGoneImageMessage">
      <span>Almost Gone!</span>
    </div>
  ) : null;
};

// * [IMPROVEMENT] if more of these computed values show up, use React.context to pass info around or memoize
// * [IMPROVEMENT] if `hasValidVariantSelected` is computed to often ^^
export const computeAlmostGoneBadging = (pdpData: IPdpData, userSelections: Partial<TUserSelection>[]) => {
  const hasAlmostGoneTag = computeHasAlmostGoneTag(pdpData.pdpProductShell.tags);
  const hasValidVariantSelected = getVariantsBySelections(pdpData, userSelections).every(
    (item) => item && item.availableForSale
  );
  return hasAlmostGoneTag && hasValidVariantSelected;
};

export const computeHasAlmostGoneTag = (tags: string[]) => tags.includes('Inventory:AlmostGone');
